module.exports = __webpack_public_path__ + "33159a93d3975b1170e3f0110f330e68.svg";